import { createSlice } from '@reduxjs/toolkit'

export interface CaseState {
  entityObject: {
    [key: string]: {
      name: string
      entityId: number
      type: string
    }
  } | null
}

const initialState: CaseState = {
  entityObject: null,
}

const localCommon = createSlice({
  name: 'localCommon',
  initialState,
  reducers: {
    setLocalEntityObject: (state, action) => {
      state.entityObject = action.payload
    },
    clearLocalEntityObject: (state) => {
      state.entityObject = null
    },
  },
})

export const { setLocalEntityObject, clearLocalEntityObject } =
  localCommon.actions
export default localCommon.reducer
